interface ImportedAccountSourceInactivityFields {
    name: string;
    isInactive: boolean;
}

/**
 * QuickBooks Online renames an account with a trailing "(deleted)" marker when
 * it is made inactive, so the suffix is a source-inactivity signal even when
 * the import path did not carry the `Active` flag.
 */
const DELETED_NAME_SUFFIX_RE = /\(deleted\)\s*$/i;

export function isImportedAccountInactiveInSource({
    name,
    isInactive,
}: ImportedAccountSourceInactivityFields): boolean {
    return isInactive || DELETED_NAME_SUFFIX_RE.test(name);
}
